import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";

function App() {
  return <PrivacyPolicy />;
}

export default App;